/****************************
*   
*   Pantomime Paty (c) 2022
*
*   Author: Oliver Borner 
*   oliverborner@gmail.com
*
*****************************/

<template>
  <div></div>
</template>

<script>

export default {
  mounted() {

    this.checkProStatus();
    //console.log(this.pantomimeData['Allgemein'].words.length)
  },
  data: function() {
    return {
        pro: false,  // Bezahlt oder nicht
        pantomimeData: {
          "Allgemein" : {
              id: 0,
              description: "Allgemeine Begriffe.",
              logo_url: "/images/categories/allgemein.svg",
              locked: false,
              active: true,
              words: [
                "Rauhfasertapete",
                "Tannenbaumständer",
                "Computer",
                "Lampenfassung",
                "Schneeketten",
                "Konfettiregen",
                "Geschenkpapier",
                "Wollschal",
                "Schleifbank",
                "Rundumleuchte",
                "Kugelbahn",
                "Schaukelpferd",
                "Verhaltensmuster",
                "Handcreme",
                "Räuchermännchen",
                "Querschläger",
                "Adventskalender",
                "Brillenputztuch",
                "Hauptgewinn",
                "Wäscheklammer",
                "Spiegelreflexkamera",
                "Pralinenschachtel",
                "Drehbuch",
                "Kinderstuhl",
                "Sonnenblumenöl",
                "Christbaumkugel",
                "Zungenkuss",
                "Ladegerät",
                "Schreihals",
                "Glühwein",
                "Osterhase",
                "Teppichklopfer",
                "Schokokringel",
                "Vollpfosten",
                "Sprudelwasser",
                "Kickstarter",
                "Eierlikör",
                "Neujahresgruß",
                "Glatteis",
                "Weihnachtsgans",
                "Lebkuchenherz",
                "Trostpreis",
                "Versuchskaninchen",
                "Regalboden",
                "Mistelzweig",
                "Hebamme",
                "Manschettenknopf",
                "Schneegestöber",
                "Rentier",
                "Winterstiefel",
                "Flussufer",
                "Pfauenfeder",
                "Ohrensessel",
                "Verlobungsring",
                "Nassrasur",
                "Garagentür",
                "Weihnachtspost",
                "Glasreiniger",
                "Gießkanne",
                "Hackebeil",
                "Tiefkühlfach",
                "Treppenhaus",
                "Fahrradschlauch",
                "Kreißsaal",
                "Mitesser",
                "Michael Jackson",
                "Bill Gates",
                "Catwoman",
                "Britney Spears",
                "Wonder Woman",
                "Paris Hilton",
                "Batman",
                "Justin Bieber",
                "Ein Zombie",
                "Erhard Schmidt",
                "Superman",
                "Der unglaubliche Hulk",
                "Albert Einstein",
                "Homer Simpson",
                "Spiderman",
                "Frankenstein",
                "Darth Vader",
                "R2D2",
                "3CPO",
                "Luke Skywalker",
                "Groupies",
                "Asyl",
                "Schlussstrich",
                "Osterhase",
                "Hexe",
                "kopieren",
                "Drehtür",
                "Waffeleisen",
                "Glühwein",
                "Nassrasur",
                "Schnittlauch",
                "Kettenkarussell",
                "Kellerassel",
                "Sesselpupser",
                "Sparschwein",
                "Büchsenöffner",
                "Teelöffel",
                "Vermögensberater",
                "Christbaumkugel",
                "Mehl",
                "Klodeckel",
                "Tandem (Fahrrad)",
                "Ehebett",
                "Nachttischlampe",
                "Hämorrhoiden",
                "Weltenbummler",
              ]
          },
          "Jobs" : {
              id: 1,
              description: "Berufe erraten.",
              logo_url: "/images/categories/jobs.svg",
              locked: false,
              active: false,
              words: [
                  "Schornsteinfeger",
                  "Zahnarzt",
                  "Busfahrer",
                  "Friseur",
                  "Pilot",
                  "Stewardess",
                  "Bauarbeiter",
                  "Klempner",
                  "Redakteur",
                  "Fernkraftfahrer",
                  "Augenoptiker",
                  "Bestatter",
                  "Bäcker",
                  "Chirurg",
                  "Dachdecker",
                  "Erzieher",
                  "Regiseur",
                  "Schauspieler",
                  "Fotograf",
                  "Hebamme",
                  "Richter",
                  "Anwalt",
                  "Koch",
                  "Polizist",
                  "Feuerwehrmann",
                  "Maskenbildner/in",
                  "Notfallsanitäter",
                  "Stuckateur",
                  "Tierpfleger",
                  "Tischler",
                  "Uhrmacher",
                  "Verkäufer",
                  "Winzer",
              ]
          },
          "Für Kinder" : {
              id: 2,
              description: "Pantomimebegriffe für Kinder",
              logo_url: "/images/categories/kids.svg",
              locked: false,
              active: false,
              words: [
                "Das Dschungelbuch",
                "Findet Nemo",
                "Katze",
                "Hund",
                "Clown",
                "Minions",
                "König der Löwen",
                "Fußball",
                "Schwimmbad",
                "Schulranzen",
                "Geschenk"
              ]
          },
          "Tiere" : {
              id: 3,
              description: "Stelle pantomimisch die Welt der Tiere dar.",
              logo_url: "/images/categories/tiere.svg",
              locked: false,
              active: false,
              words: [
                "Elefant",
                "Maus",
                "Katze",
                "Hund",
                "Kuh",
                "Fuchs",
                "Affe",
                "Schlange",
                "Fledermaus",
                "Papagei",
                "Nilpferd",
                "Gorilla",
                "Giraffe",
                "Pfau",
                "Flamingo",
                "Hai",
                "Delfin",
                "Seestern",
                "Tintenfisch",
                "Kamel",
                "Stier",
                "Steinadler",
                "Salamander",
                "Schwein",
                "Pferd"
              ]
          },
          "Film" : {
              id: 5,
              description: "Filme erraten.",
              logo_url: "/images/categories/film.svg",
              locked: true,
              active: false,
              words: [
                "Matrix",
                "Terminator",
                "Titanic",
                "Apocalypse Now",
                "Das Schweigen der Lämmer",
                "Stirb Langsam",
                "Forest Gump",
                "Der Teufel trägt Prada",
                "Die fabelhafte Welt der Amélie",
                "Titanic",
                "Ghostbusters",
                "Bridget Jones – Schokolade zum Frühstück",
                "Gremlins",
                "Saw",
                "Batman",
                "Goodfellas",
                "Otto(Walkes) der Film",
                "Shrek",
                "Pulp Fiction",
                "Der Pate",
                "American Beauty",
                "Lola rennt",
                "Fight Club",
                "Toy Story",
                "Alien",
                "Kevin allein zu Haus",
                "The Departed",
                "Inception",
                "König der Löwen",
                "Twilight",
                "Steppenwolf",
                "50 Shades of Grey",
                "Charlie und die Schokoladenfabrik",
                "Das Mädchen mit dem Drachentattoo",
                "Romeo und Julia",
              ]
          },
          "Für Erwachsene" : {
              id: 4,
              description: "Der erotische Rateabend kann beginnen.",
              logo_url: "/images/categories/erwachsene.svg",
              locked: true,
              active: false,
              words: [
                "Domina",
                "One Night Stand",
                "Strippen / Stripper",
                "Orgie",
                "Kondom",
                "Blowjob",
                "Zungenkuss",
                "Busensex",
                "SM-Spiele",
                "Intimpiercing",
                "Vibrator",
                "Intimrasur",
                "69er-Stellung",
                "Analsex",
                "Besetzungscouch",
                "Milf",
                "Fußerotik",
                "Missionarsstellung",
                "Kamasutra",
              ]
          },
           "Städte" : {
              id: 6,
              description: "Kannst du diese Städte pantomimisch darstellen?",
              logo_url: "/images/categories/cities.svg",
              locked: true,
              active: false,
              words: [
                "Hongkong",
                "Bangkok",
                "London",
                "Dubai",
                "Paris",
                "New York City",
                "Rom",
                "Tokio",
                "Amsterdam",
                "Miami",
                "Las Vegas",
                "Barcelona",
                "Mailand",
                "Wien",
                "Berlin",
                "München",
                "Athen",
                "Kairo",
                "Moskau",
                "Venedig",
                "Madrid",
                "Sydney",
                "Peking",
                "Jerusalem",
                "Lissabon",
                "Vancouver",
                "San Fransisco",
                "Tel Aviv",
                "Honolulu",
                "Frankfurt am Main",
                "Stockholm",
                "Rio de Janeiro",
                "Waschington"
              ]
          },
           "Länder" : {
              id: 7,
              description: "Länder erraten.",
              logo_url: "/images/categories/countries.svg",
              locked: true,
              active: false,
              words: [
                "Frankreich",
                "Spanien",
                "Vereinigte Staaten (USA)",
                "China",
                "Italien",
                "Türkei",
                "Mexico",
                "Deutschland",
                "Thailand",
                "Vereinigtes Königreich",
                "Japan",
                "Österreich",
                "Griechenland",
                "Hongkong",
                "Malaysia",
                "Russland",
                "Portugal",
                "Kanada",
                "Polen",
                "Niederlande",
                "Indien",
                "Ungarn",
                "Kroation",
                "Vietnam",
                "Nordkorea",
                "Südkorea",
                "Saudi-Arabien",
                "Tschechien",
                "Dänemark",
                "Marokko",
                "Schweiz",
                "Ägypten",
                "Südafrika",
                "Irland",
                "Australien",
                "Belgien",
                "Iran",
                "Philippinen",
                "Schweden",
                "Brasilien",
                "Argentinien",
                "Norwegen",
                "Georgien",
                "Israel",
                "Finnland",
                "Jamaika"
              ]
          },
          
        }
      };
    },

    methods:{

      fetchData(){
        this.checkProStatus();
        return this.pantomimeData;
      },

      fetchCategories(){
        this.checkProStatus();
        return Object.entries(this.pantomimeData);
      },

      getProStatus()
      {
        return this.pro;
      },

      checkProStatus() {
        // if pro -> unlock all categories
        if(this.pro) {
          Object.entries(this.pantomimeData).forEach(val => {
              if(val[1].locked) {
                val[1].locked = false;
              }
          });
        }
      }

    },

}
</script>
